jQuery(function () {
    // お問合せボタン ヘッダー
    const headerContact = $('.global-contact')
    headerContact.mouseenter(() => {
        $(".global-contact img").attr('src', './image/header/pc-contact-hover.png')
    }).mouseleave(() => {
        $(".global-contact img").attr('src', './image/header/pc-contact.png')
    });

    // お問合せボタン お問合せバナー
    const bannerContact = $('.contact-banner-mail')
    bannerContact.mouseenter(() => {
        $(".contact-banner-mail img").attr('src', './image/contact/banner/contact-hover.png')
    }).mouseleave(() => {
        $(".contact-banner-mail img").attr('src', './image/contact/banner/contact.png')
    });

    // 送信ボタン フォーム
    // const submitButton = $('#submit-button');
    // submitButton.mouseenter(() => {
    //     $("#submit-button").attr('src', './image/contact/form/submit-hover.png')
    // }).mouseleave(() => {
    //     $("#submit-button").attr('src', './image/contact/form/submit.png')
    // });
    
    const pageTop = $('.page-top')
    pageTop.mouseenter(() => {
        $(".page-top img").attr('src', './image/fixed/pagetop-hover.png')
    }).mouseleave(() => {
        $(".page-top img").attr('src', './image/fixed/pagetop.png')
    });
});
